import React, { useEffect, useState } from 'react';
import { Button, Tooltip } from 'reactstrap';
import uniqueId from 'lodash/uniqueId';
import ITooltipButton from '../interfaces/ITooltipButton';

const TooltipButton = ({
  id: _id,
  tooltip,
  children,
  className,
  color,
  size,
  disabled,
  onClick,
  loading,
  mobileLabel,
  href,
  target,
  outline,
  style,
} : ITooltipButton) => {
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);
  const [width, setWidth] = useState(window.innerWidth);
  const [id, setId] = useState(_id || `tooltip-button-${uniqueId()}`);

  useEffect(() => {
    setId(id);
  }, [id]);

  useEffect(() => {
    const handleWindowResize = () => setWidth(window.innerWidth);
    window.addEventListener('resize', handleWindowResize);

    return () => window.removeEventListener('resize', handleWindowResize);
  });

  const toggleTooltip = () => setIsTooltipOpen((i) => !i);

  const isMobile = width <= 500;

  return (
    <>
      <span id={id} style={{ display: 'inline-block' }}>
        <Button
          color={color}
          size={size}
          onClick={onClick}
          disabled={disabled}
          href={href}
          target={target}
          style={{ ...style, pointerEvents: disabled ? 'none' : 'auto' }}
          className={className}
          outline={outline}
        >
          {loading && <span className="btn-inner--icon"><i className="ni ni-settings-gear-65 spin" /></span>}
          {isMobile && mobileLabel ? mobileLabel : children}
        </Button>
      </span>
      {tooltip && (
        <Tooltip
          isOpen={isTooltipOpen}
          target={id}
          toggle={toggleTooltip}
          trigger="hover"
        >
          {tooltip}
        </Tooltip>
      )}
    </>
  );
};

export default TooltipButton;
